import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Tabs,
  Input,
  Checkbox,
  Button,
  Tag,
  Typography,
  Empty,
  Spin,
  Card,
  Space,
} from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { EvaluationDetailModal } from "../../../EvaluationsCmp/EvaluationDetailModal/EvaluationDetailModal";

const { Text } = Typography;

function EvalCard({ ev, checked, onToggle, onPreview }) {
  // "Ver" sale del bloque comun; el resto es propio de esta pantalla.
  const { t } = useTranslation(["rooms", "common"]);

  return (
    <Card size="small" className="revi-eval-picker-card">
      <div className="revi-eval-picker-row">
        <div className="revi-eval-picker-left">
          <Checkbox checked={checked} onChange={() => onToggle(ev._id)} />
          <div>
            <Text strong>
              {ev?.title || t("asistenteEscena.paso3.evaluacionSinTitulo")}
            </Text>

            <div className="revi-eval-picker-tags">
              {ev?.type === "standardized" ? (
                <Tag color="purple">
                  {t("asistenteEscena.paso3.tipoEstandar")}
                </Tag>
              ) : (
                <Tag>{t("asistenteEscena.paso3.tipoPropia")}</Tag>
              )}
              {ev?.subtype ? <Tag>{ev.subtype}</Tag> : null}
              {ev?.visibility ? <Tag>{ev.visibility}</Tag> : null}
            </div>
          </div>
        </div>

        <Button
          size="small"
          icon={<EyeOutlined />}
          onClick={() => onPreview(ev)}
        >
          {t("common:actions.view")}
        </Button>
      </div>
    </Card>
  );
}

export function Step3SelectEvaluations({
  tab,
  onTabChange,
  search,
  onSearch,
  loading,
  standardEvaluations,
  myEvaluations,
  selectedEvalIds,
  onToggle,
  onPreview,

  previewOpen,
  previewLoading,
  previewEvaluation,
  onClosePreview,
}) {
  const { t } = useTranslation("rooms");

  const list = useMemo(() => {
    if (tab === "my") return myEvaluations || [];
    return standardEvaluations || [];
  }, [tab, standardEvaluations, myEvaluations]);

  return (
    <div className="wizard-step">
      <div className="form-section">
        <h5>{t("asistenteEscena.paso3.titulo")}</h5>

        <Tabs
          activeKey={tab}
          onChange={onTabChange}
          items={[
            { key: "standard", label: t("asistenteEscena.paso3.tabEstandar") },
            { key: "my", label: t("asistenteEscena.paso3.tabMias") },
          ]}
        />

        <Input.Search
          placeholder={t("asistenteEscena.paso3.buscarPlaceholder")}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          allowClear
          style={{ marginBottom: 12 }}
        />

        {/* Concuerda en genero con "evaluaciones", asi que la frase entera
            tiene que ser traducible, no solo la palabra. */}
        <Text type="secondary">
          {t("asistenteEscena.paso3.seleccionadas", {
            count: selectedEvalIds.length,
          })}
        </Text>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
          <Spin />
        </div>
      ) : list.length === 0 ? (
        <Empty description={t("asistenteEscena.paso3.vacio")} />
      ) : (
        <Space orientation="vertical" style={{ width: "100%" }} size={10}>
          {list.map((ev) => (
            <EvalCard
              key={ev._id}
              ev={ev}
              checked={selectedEvalIds.includes(ev._id)}
              onToggle={onToggle}
              onPreview={onPreview}
            />
          ))}
        </Space>
      )}

      <EvaluationDetailModal
        isOpen={previewOpen}
        onClose={onClosePreview}
        evaluation={previewEvaluation}
        loading={previewLoading}
      />
    </div>
  );
}
